import useSWR from "swr";
import MercadoLibreService from "services/MercadoLibreService";

const useMercadoLibreCategories = (categoryId = null, shouldFetch = true) => {
    const { data, error, isValidating } = useSWR(
        shouldFetch ? ["mercadolibre-categories", categoryId] : null,
        () => MercadoLibreService.getCategories(categoryId),
        {
            revalidateOnFocus: false,
            shouldRetryOnError: false,
        }
    );

    return {
        categories: data || [],
        isLoading: isValidating && !data,
        isError: error,
    };
};

export default useMercadoLibreCategories;
